import React from 'react'

export default function NoMediaGenerated({close, remainder = 0}) {


    if (!remainder || remainder < 1) {
        return (
            <div>
                <div>
                    <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
                        <div className="bg-white mx-auto rounded shadow p-5 text-center" style={{maxWidth: '90%', width: '1000px'}}>
                            <h4>⚠️ No Post Generated</h4>

                            <div style={{textAlign: 'left'}}>
                                <p>We couldn’t generate any posts. This may be due to one or more of the following reasons:</p>
                                <ul style={{listStyle: 'inside'}}>
                                    <li>No media files have been uploaded</li>
                                    <li>Media file names do not include a valid <code>{`{{Import ID}}`}</code></li>
                                    <li>The IDs in the filenames don’t match any active users</li>
                                    <li>Required fields like a template or valid users are missing</li>
                                </ul>
                                <p>
                                    Please double-check your uploaded media and ensure filenames follow the format:
                                    <br />
                                    <code>File Name {`{{123}}`}.pdf</code> — where <code>123</code> is the Import ID of a valid sender.
                                </p>
                            </div>

                            <div className="pt-3">
                                <button onClick={close} type="button" className="btn btn-secondary mr-2">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>  
                </div>
            </div>
        )
    }
  return (
    <div>
        <div>
            <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div className="bg-white mx-auto rounded shadow p-5 text-center" style={{ maxWidth: '90%', width: '1000px' }}>
                <h4>⚠️ {remainder} Media File{remainder === 1 ? '' : 's'} Not Used</h4>

                <div style={{ textAlign: 'left' }}>
                <p>
                    {remainder} media file{remainder === 1 ? '' : 's'} were not used to create posts. This is most likely because the file name format was incorrect and didn’t match the required <code>{`{{Import ID}}`}</code> pattern.
                </p>
                <p>
                    Please make sure each filename includes an Import ID like:
                    <br />
                    <code>File Name {`{{123}}`}.pdf</code>
                </p>
                </div>

                <div className="pt-3">
                    <button onClick={close} type="button" className="btn btn-danger mr-2">
                        Close
                    </button>
                    <button onClick={() => {
                        window.location = '/group/post/media'
                    }} type="button" className='btn btn-primary'>
                        Edit Upload
                    </button>
                </div>
            </div>
            </div>
        </div>
    </div>
  )
}
